import { Colors } from '..';
import generateGradient from './generateGradient';

const purple = {
  conical: generateGradient(
    [Colors.Purple[600], Colors.Purple[25]],
    'conical',
    {},
    {
      originDeg: 259.08,
      originX: 50,
      originY: 50,
      deg: [0, 360],
    }
  ),
  linear01: generateGradient(
    [Colors.Purple[600], Colors.Purple[500]],
    'linear',
    {
      originDeg: 90,
      percent: [0, 100],
    }
  ),
  linear02: generateGradient(
    [Colors.Purple[700], Colors.Purple[600]],
    'linear',
    {
      originDeg: 45,
      percent: [0, 100],
    }
  ),
  linear03: generateGradient(
    [Colors.Purple[800], Colors.Purple[600]],
    'linear',
    {
      originDeg: 45,
      percent: [0, 100],
    }
  ),
  linear04: generateGradient(
    [Colors.Purple[800], Colors.Purple[600]],
    'linear',
    {
      originDeg: 90,
      percent: [0, 100],
    }
  ),
  linear05: generateGradient(
    [Colors.Purple[800], Colors.Purple[700]],
    'linear',
    {
      originDeg: 26.5,
      percent: [0, 100],
    }
  ),
  linear06: generateGradient(
    [Colors.Purple[900], Colors.Purple[600]],
    'linear',
    {
      originDeg: 45,
      percent: [0, 100],
    }
  ),
} as const;

export default purple;
